import { useEffect, useState } from "react";
import { API, getToken } from "@/lib/api";

/**
 * Fetches a private file with an Authorization header and renders the
 * resulting bytes as an <img>. This avoids putting the bearer token in
 * the URL query string (which leaks into server access logs, proxy logs,
 * and browser history) — a HIPAA-relevant hardening.
 */
export default function AuthImage({ fileId, alt = "", className = "", ...rest }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!fileId) return;
    let cancelled = false;
    let url = null;
    const token = getToken();
    fetch(`${API}/files/${fileId}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
      .then((r) => {
        if (!r.ok) throw new Error("fetch failed");
        return r.blob();
      })
      .then((blob) => {
        if (cancelled) return;
        url = URL.createObjectURL(blob);
        setBlobUrl(url);
      })
      .catch(() => !cancelled && setError(true));
    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [fileId]);

  if (error) {
    return <div className={`bg-[#EBE8E0]/40 flex items-center justify-center text-xs text-[#576A62] ${className}`}>Image unavailable</div>;
  }
  if (!blobUrl) {
    return <div className={`bg-[#EBE8E0]/40 animate-pulse ${className}`} />;
  }
  return <img src={blobUrl} alt={alt} className={className} {...rest} />;
}
